export const COOKIE_SUBMISSION_ID = 'user_submission_id';
export const COOKIE_SUBMITTED_FOLLOW_UP = 'submitted_follow_up';